import { defineMessages } from '@cookbook/solid-intl'

// Split out of `calendar-page.messages.en.js` so the router's document-title/meta-
// description wiring doesn't have to eagerly pull that entire page's messages file
// into the boot-critical chunk just for these strings. Same pattern/rationale as
// `booking-management-page-routing.messages.en.js` (TENANT-5036 bundle audit).
//
// There is deliberately no `-routing.messages.fr-ca.js` / `-routing.messages.es-mx.js`:
// the locale glob in `src/app/messages/index.jsx` keys on the message ID, and both
// ids below are carried by `calendar-page.messages.{fr-ca,es-mx}.js`.
export const messages = {
    descriptionMessage: defineMessages({
        defaultMessage: 'See one listing’s calendar on Lodgr — scroll month to month across your availability and pricing.',
        id: 'CalendarPage.descriptionMessage',
    }),
    titleMessage: defineMessages({
        defaultMessage: 'Calendar | Lodgr',
        id: 'CalendarPage.titleMessage',
    }),
}
